var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAiReply = function SvgAiReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.5 7.5 4.166 4.167m0 0-4.167 4.166m4.167-4.166H9.333a6 6 0 0 1-6-6V5",
    stroke: "url(#ai-reply_svg__a)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai-reply_svg__a",
    x1: 14.512,
    y1: 10.753,
    x2: 4.162,
    y2: 10.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4664FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.939,
    stopColor: "#966CDB"
  })))));
};

export default SvgAiReply;